import { Component, computed, Input, OnDestroy, OnInit, Signal, signal, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgOptimizedImage } from '@angular/common';
import { OffcanvasService } from '../../../../_services/offcanvas-service/offcanvas.service';
import { Card, CardType } from '../../../../_interfaces/cards.interface';
import { CardsApiService } from '../../../../_services/cards-service/cards-api/cards-api.service';
import { ToastService } from '../../../../_services/toast-service/toast.service';
import { Subscription } from 'rxjs';
import { OffcanvasHeaderBtnComponent } from '../../offcanvas/offcanvas-header-btn/offcanvas-header-btn.component';
import { OffcanvasBaseComponent } from '../../offcanvas/offcanvas-base/offcanvas-base.component';

@Component({
  selector: 'app-replace-card',
  imports: [FormsModule, ReactiveFormsModule, NgOptimizedImage, OffcanvasHeaderBtnComponent, OffcanvasBaseComponent],
  templateUrl: './replace-card.component.html',
})
export class ReplaceCardComponent implements OnInit, OnDestroy {
  readonly offcanvasService = inject(OffcanvasService);
  readonly cardsApiService = inject(CardsApiService);
  readonly toastService = inject(ToastService);

  @Input({ required: true }) cardDetails!: Card;
  @Input({ required: true }) cardType!: CardType;

  readonly subscriptions = new Subscription();
  protected cardId!: number;
  protected isEmployeeCard = signal(false);

  protected returnUrl: Signal<string> = computed<string>(() => {
    if (this.cardType === CardType.Personal) return 'cards/employee-cards';
    if (this.cardType === CardType.Subscription) return 'cards/subscription-cards';
    return '';
  });

  ngOnInit() {
    this.isEmployeeCard.set(this.cardDetails?.type === CardType.Personal);
    this.cardId = this.cardDetails?.id;
  }

  close(): void {
    this.offcanvasService.close(this.returnUrl());
  }

  onReplaceCard() {
    this.subscriptions.add(
      this.cardsApiService.replaceCard(this.cardId).subscribe({
        next: () => {
          if (this.cardType === CardType.Personal) {
            this.toastService.show('You have replaced an employee card.', 'iconoir-check-circle');
          }
          if (this.cardType === CardType.Subscription) {
            this.toastService.show('You have replaced a subscription card.', 'iconoir-check-circle');
          }
          this.close();
        },
        error: (error) => {
          this.toastService.show(`Something went wrong. ${error.error.card}`, 'iconoir-xmark');
        },
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
